import { CASES, OFFERS_FILTERS_STORAGE_KEY } from "./constants";

/**
 * Updates offer-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the offers slice
 */
export const updateOffers = (payload) => {
  return { type: CASES.UPDATE_OFFERS, payload };
};

/**
 * Updates the internal filters used for offer filtering.
 * Merges with existing filters.
 * @param {Object} payload - Filter values to merge into internalFilters
 * @param {string} jobId - Job ID to persist filters for
 */
export const updateOffersFilters = (payload, jobId) => {
  return {
    type: CASES.UPDATE_OFFERS_FILTERS,
    payload: { filters: payload, jobId },
  };
};

/**
 * Sets the internal filters (replaces all filters) and persists to localStorage.
 * @param {Object} filters - Complete filter state to set
 * @param {string} jobId - Job ID to persist filters for
 */
export const setOffersFilters = (filters, jobId) => {
  return { type: CASES.SET_OFFERS_FILTERS, payload: { filters, jobId } };
};

/**
 * Loads saved filters from localStorage for a specific job.
 * @param {string} jobId - Job ID to load filters for
 */
export const loadOffersFilters = (jobId) => {
  let savedFilters = {};
  try {
    const stored = localStorage.getItem(
      `${OFFERS_FILTERS_STORAGE_KEY}${jobId}`,
    );
    if (stored) {
      savedFilters = JSON.parse(stored);
    }
  } catch (e) {
    console.warn("Failed to load saved filters:", e);
  }
  return { type: CASES.LOAD_OFFERS_FILTERS, payload: savedFilters };
};

/**
 * Resets the offers state to initial values, preserving column visibility preferences.
 */
export const clearOffers = () => {
  return { type: CASES.CLEAR_OFFERS, payload: {} };
};

/**
 * Clears all filter values and search text without resetting other state.
 * @param {string} jobId - Optional job ID to clear persisted filters for
 */
export const clearOffersFilters = (jobId) => {
  if (jobId) {
    try {
      localStorage.removeItem(`${OFFERS_FILTERS_STORAGE_KEY}${jobId}`);
    } catch (e) {
      console.warn("Failed to clear saved filters:", e);
    }
  }
  return { type: CASES.CLEAR_OFFERS_FILTERS, payload: {} };
};
